module.exports = new __parcel__URL__("demo-icon.3d87ab8f.svg").toString();